export const debauchery = [
  {
    number: '01',
    hasModel: false
  },
  {
    number: '02',
    hasModel: false
  },
  {
    number: '03',
    hasModel: false
  },
  {
    number: '04',
    hasModel: false
  },
  {
    number: '05',
    hasModel: false
  },
  {
    number: '06',
    hasModel: false
  },
  {
    number: '07',
    hasModel: false
  },
  {
    number: '08',
    hasModel: false
  },
  {
    number: '09',
    hasModel: false
  },
  {
    number: '10',
    hasModel: false
  },
  {
    number: '11',
    hasModel: false
  },
  {
    number: '12',
    hasModel: false
  },
  {
    number: '13',
    hasModel: false
  },
  {
    number: '14',
    hasModel: false
  },
  {
    number: '15',
    hasModel: false
  },
  {
    number: '16',
    hasModel: false
  },
  {
    number: '17',
    hasModel: false
  },
  {
    number: '18',
    hasModel: false
  },
  {
    number: '19',
    hasModel: false
  },
  {
    number: '20',
    hasModel: false
  },

]